module.exports = __webpack_public_path__ + "img/xiaojuren.058dcca3.png";